// UNIVERSITY DATABASE
// Comprehensive list of top universities worldwide with coordinates

export const UNIVERSITY_DB = [
  // ═══════════════════════════════════════════════════════════════
  // UNITED STATES
  // ═══════════════════════════════════════════════════════════════
  { id: 1, name: "Stanford University", coords: [37.4275, -122.1697], country: "us" },
  { id: 2, name: "MIT", coords: [42.3601, -71.0942], country: "us" },
  { id: 3, name: "Harvard University", coords: [42.3770, -71.1167], country: "us" },
  { id: 4, name: "UC Berkeley", coords: [37.8715, -122.2730], country: "us" },
  { id: 5, name: "Yale University", coords: [41.3163, -72.9223], country: "us" },
  { id: 6, name: "Princeton University", coords: [40.3431, -74.6551], country: "us" },
  { id: 7, name: "Columbia University", coords: [40.8075, -73.9626], country: "us" },
  { id: 8, name: "University of Chicago", coords: [41.7886, -87.5987], country: "us" },
  { id: 9, name: "Caltech", coords: [34.1377, -118.1253], country: "us" },
  { id: 10, name: "Cornell University", coords: [42.4534, -76.4735], country: "us" },
  { id: 11, name: "University of Pennsylvania", coords: [39.9522, -75.1932], country: "us" },
  { id: 12, name: "Duke University", coords: [36.0014, -78.9382], country: "us" },
  { id: 13, name: "Northwestern University", coords: [42.0565, -87.6753], country: "us" },
  { id: 14, name: "Johns Hopkins University", coords: [39.3299, -76.6205], country: "us" },
  { id: 15, name: "Dartmouth College", coords: [43.7044, -72.2887], country: "us" },
  { id: 16, name: "Brown University", coords: [41.8268, -71.4025], country: "us" },
  { id: 17, name: "Vanderbilt University", coords: [36.1447, -86.8027], country: "us" },
  { id: 18, name: "Rice University", coords: [29.7174, -95.4018], country: "us" },
  { id: 19, name: "UCLA", coords: [34.0689, -118.4452], country: "us" },
  { id: 20, name: "USC", coords: [34.0224, -118.2851], country: "us" },
  { id: 21, name: "Carnegie Mellon University", coords: [40.4433, -79.9436], country: "us" },
  { id: 22, name: "University of Michigan", coords: [42.2780, -83.7382], country: "us" },
  { id: 23, name: "NYU", coords: [40.7295, -73.9965], country: "us" },
  
  // ═══════════════════════════════════════════════════════════════
  // UNITED KINGDOM
  // ═══════════════════════════════════════════════════════════════
  { id: 30, name: "Oxford University", coords: [51.7548, -1.2544], country: "gb" },
  { id: 31, name: "Cambridge University", coords: [52.2043, 0.1218], country: "gb" },
  { id: 32, name: "Imperial College London", coords: [51.4988, -0.1749], country: "gb" },
  { id: 33, name: "London School of Economics", coords: [51.5144, -0.1167], country: "gb" },
  { id: 34, name: "UCL", coords: [51.5246, -0.1340], country: "gb" },
  { id: 35, name: "University of Edinburgh", coords: [55.9445, -3.1892], country: "gb" },
  { id: 36, name: "King's College London", coords: [51.5115, -0.1160], country: "gb" },
  { id: 37, name: "University of Manchester", coords: [53.4668, -2.2339], country: "gb" },
  { id: 38, name: "University of Warwick", coords: [52.3791, -1.5605], country: "gb" },
  
  // ═══════════════════════════════════════════════════════════════
  // CANADA
  // ═══════════════════════════════════════════════════════════════
  { id: 50, name: "University of Toronto", coords: [43.6629, -79.3957], country: "ca" },
  { id: 51, name: "UBC", coords: [49.2606, -123.2460], country: "ca" },
  { id: 52, name: "McGill University", coords: [45.5048, -73.5772], country: "ca" },
  { id: 53, name: "University of Waterloo", coords: [43.4723, -80.5449], country: "ca" },
  
  // ═══════════════════════════════════════════════════════════════
  // AUSTRALIA
  // ═══════════════════════════════════════════════════════════════
  { id: 60, name: "University of Melbourne", coords: [-37.7964, 144.9612], country: "au" },
  { id: 61, name: "University of Sydney", coords: [-33.8886, 151.1873], country: "au" },
  { id: 62, name: "UNSW Sydney", coords: [-33.9173, 151.2313], country: "au" },
  { id: 63, name: "ANU", coords: [-35.2777, 149.1185], country: "au" },
  
  // ═══════════════════════════════════════════════════════════════
  // SINGAPORE
  // ═══════════════════════════════════════════════════════════════
  { id: 70, name: "National University of Singapore", coords: [1.2966, 103.7764], country: "sg" },
  { id: 71, name: "Nanyang Technological University", coords: [1.3483, 103.6831], country: "sg" },
  
  // ═══════════════════════════════════════════════════════════════
  // HONG KONG
  // ═══════════════════════════════════════════════════════════════
  { id: 80, name: "University of Hong Kong", coords: [22.2830, 114.1350], country: "hk" },
  { id: 81, name: "HKUST", coords: [22.3364, 114.2655], country: "hk" },
  
  // ═══════════════════════════════════════════════════════════════
  // FRANCE
  // ═══════════════════════════════════════════════════════════════
  { id: 90, name: "Sorbonne University", coords: [48.8467, 2.3570], country: "fr" },
  { id: 91, name: "Sciences Po", coords: [48.8542, 2.3260], country: "fr" },
  { id: 92, name: "HEC Paris", coords: [48.7594, 2.1686], country: "fr" },
  
  // ═══════════════════════════════════════════════════════════════
  // GERMANY
  // ═══════════════════════════════════════════════════════════════
  { id: 100, name: "TU Munich", coords: [48.1497, 11.5676], country: "de" },
  { id: 101, name: "LMU Munich", coords: [48.1507, 11.5810], country: "de" },
  { id: 102, name: "Heidelberg University", coords: [49.4093, 8.7067], country: "de" },
  
  // ═══════════════════════════════════════════════════════════════
  // SWITZERLAND
  // ═══════════════════════════════════════════════════════════════
  { id: 110, name: "ETH Zurich", coords: [47.3769, 8.5417], country: "ch" },
  { id: 111, name: "EPFL", coords: [46.5191, 6.5668], country: "ch" },
  
  // ═══════════════════════════════════════════════════════════════
  // ITALY
  // ═══════════════════════════════════════════════════════════════
  { id: 120, name: "Bocconi University", coords: [45.4509, 9.1895], country: "it" },
  
  // ═══════════════════════════════════════════════════════════════
  // JAPAN
  // ═══════════════════════════════════════════════════════════════
  { id: 130, name: "University of Tokyo", coords: [35.7126, 139.7621], country: "jp" },
  { id: 131, name: "Kyoto University", coords: [35.0261, 135.7817], country: "jp" },
  
  // ═══════════════════════════════════════════════════════════════
  // CHINA
  // ═══════════════════════════════════════════════════════════════
  { id: 140, name: "Tsinghua University", coords: [40.0003, 116.3261], country: "cn" },
  { id: 141, name: "Peking University", coords: [39.9925, 116.3160], country: "cn" },
  
  // ═══════════════════════════════════════════════════════════════
  // NETHERLANDS
  // ═══════════════════════════════════════════════════════════════
  { id: 150, name: "University of Amsterdam", coords: [52.3676, 4.9041], country: "nl" },
  { id: 151, name: "Delft University", coords: [51.9987, 4.3731], country: "nl" },
  { id: 251, name: "Vrije Universiteit Amsterdam", coords: [52.3339, 4.8657], country: "nl" },
  // ═══════════════════════════════════════════════════════════════
  // SPAIN
  // ═══════════════════════════════════════════════════════════════
  { id: 160, name: "IE University", coords: [40.4168, -3.7038], country: "es" },
  { id: 161, name: "ESADE", coords: [41.3933, 2.1184], country: "es" },
  
  // ═══════════════════════════════════════════════════════════════
  // SWEDEN
  // ═══════════════════════════════════════════════════════════════
  { id: 170, name: "KTH Royal Institute", coords: [59.3498, 18.0686], country: "se" },
  
  // ═══════════════════════════════════════════════════════════════
  // INDIA
  // ═══════════════════════════════════════════════════════════════
  { id: 180, name: "IIT Bombay", coords: [19.1334, 72.9133], country: "in" },
  { id: 181, name: "IIT Delhi", coords: [28.5449, 77.1926], country: "in" },

  // ═══════════════════════════════════════════════════════════════
  // ASIA (ADDITIONAL)
  // ═══════════════════════════════════════════════════════════════
  { id: 201, name: "Kyoto University", coords: [35.0262, 135.7808], country: "jp" },
  { id: 202, name: "Fudan University", coords: [31.2989, 121.5028], country: "cn" },
  { id: 203, name: "KAIST", coords: [36.3721, 127.3603], country: "kr" },
  { id: 204, name: "Chinese University of Hong Kong", coords: [22.4195, 114.2068], country: "hk" },
  { id: 205, name: "Shanghai Jiao Tong University", coords: [31.0253, 121.4333], country: "cn" },
  { id: 206, name: "Zhejiang University", coords: [30.3006, 120.0885], country: "cn" },
  { id: 207, name: "Osaka University", coords: [34.8215, 135.5234], country: "jp" },
  { id: 208, name: "Yonsei University", coords: [37.5658, 126.9385], country: "kr" },
  { id: 209, name: "Korea University", coords: [37.5894, 127.0323], country: "kr" },
  { id: 210, name: "National Taiwan University", coords: [25.0174, 121.5405], country: "tw" },
  { id: 211, name: "Universiti Malaya", coords: [3.1209, 101.6538], country: "my" },
  { id: 212, name: "Tohoku University", coords: [38.2542, 140.8721], country: "jp" },
  { id: 213, name: "Chulalongkorn University", coords: [13.7367, 100.5331], country: "th" },
  { id: 214, name: "Universitas Indonesia", coords: [-6.3606, 106.8272], country: "id" },
  { id: 215, name: "Hokkaido University", coords: [43.0747, 141.3414], country: "jp" },
  { id: 216, name: "National Tsing Hua University", coords: [24.7961, 120.9967], country: "tw" },
  { id: 217, name: "Nagoya University", coords: [35.1549, 136.9667], country: "jp" },
  { id: 218, name: "Universiti Teknologi Malaysia", coords: [1.5588, 103.6375], country: "my" },

  // ═══════════════════════════════════════════════════════════════
  // SOUTH AMERICA
  // ═══════════════════════════════════════════════════════════════
  { id: 219, name: "Universidade de São Paulo", coords: [-23.5594, -46.7235], country: "br" },
  { id: 220, name: "Pontificia Universidad Católica de Chile", coords: [-33.4406, -70.6406], country: "cl" },
  { id: 221, name: "Universidad de Buenos Aires", coords: [-34.5986, -58.3811], country: "ar" },
  { id: 222, name: "Universidade Estadual de Campinas", coords: [-22.8175, -47.0697], country: "br" },
  { id: 223, name: "Universidad de Chile", coords: [-33.4442, -70.6536], country: "cl" },
  { id: 224, name: "Universidad Nacional Autónoma de México", coords: [19.3321, -99.1872], country: "mx" },
  { id: 225, name: "Universidad de los Andes", coords: [4.6014, -74.0649], country: "co" },
  { id: 226, name: "Universidade Federal do Rio de Janeiro", coords: [-22.8631, -43.2244], country: "br" },
  { id: 227, name: "Tecnológico de Monterrey", coords: [25.6514, -100.2895], country: "mx" },
  { id: 228, name: "Pontificia Universidad Católica del Perú", coords: [-12.0695, -77.0801], country: "pe" },
  { id: 229, name: "Universidad Nacional de Colombia", coords: [4.6382, -74.0841], country: "co" },
  { id: 230, name: "Universidad de Concepción", coords: [-36.8297, -73.0383], country: "cl" },
  { id: 231, name: "Universidade Federal de Minas Gerais", coords: [-19.8690, -43.9664], country: "br" },
  { id: 232, name: "Universidad de Santiago de Chile", coords: [-33.4503, -70.6849], country: "cl" },

  // ═══════════════════════════════════════════════════════════════
  // EASTERN EUROPE
  // ═══════════════════════════════════════════════════════════════
  { id: 233, name: "Lomonosov Moscow State University", coords: [55.7028, 37.5308], country: "ru" },
  { id: 234, name: "Charles University", coords: [50.0880, 14.4020], country: "cz" },
  { id: 235, name: "University of Warsaw", coords: [52.2403, 21.0185], country: "pl" },
  { id: 236, name: "Jagiellonian University", coords: [50.0614, 19.9333], country: "pl" },
  { id: 237, name: "Saint Petersburg State University", coords: [59.9419, 30.2991], country: "ru" },
  { id: 238, name: "University of Tartu", coords: [58.3811, 26.7198], country: "ee" },
  { id: 239, name: "Eötvös Loránd University", coords: [47.4912, 19.0592], country: "hu" },
  { id: 240, name: "Masaryk University", coords: [49.1986, 16.6044], country: "cz" },
  { id: 241, name: "University of Bucharest", coords: [44.4355, 26.1012], country: "ro" },
  { id: 252, name: "Politehnica University of Bucharest", coords: [44.4385, 26.0515], country: "ro" },
  { id: 242, name: "University of Ljubljana", coords: [46.0494, 14.5041], country: "si" },
  { id: 243, name: "Warsaw University of Technology", coords: [52.2220, 21.0070], country: "pl" },
  { id: 244, name: "Comenius University in Bratislava", coords: [48.1450, 17.1158], country: "sk" },
  { id: 245, name: "Taras Shevchenko National University of Kyiv", coords: [50.4418, 30.5111], country: "ua" },
  { id: 246, name: "University of Belgrade", coords: [44.8186, 20.4573], country: "rs" },
  { id: 247, name: "Vilnius University", coords: [54.6831, 25.2878], country: "lt" },
  { id: 248, name: "Czech Technical University in Prague", coords: [50.1035, 14.3934], country: "cz" },
  { id: 249, name: "Semmelweis University", coords: [47.4891, 19.0683], country: "hu" },
  { id: 250, name: "University of Zagreb", coords: [45.8114, 15.9698], country: "hr" },
  
];